export default __webpack_public_path__ + "static/media/sinalPending.c88043d3.svg";